export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-problem-2.9d938b69.png";